import * as Yup from "yup";
import { emailRegex, passwordRegex } from "./validationRegex";
import { validationErrors, fieldLengths } from "./validationRules";

const validationUtils = {
  validateEmail: (options = {}) => {
    const {
      requiredMessage = validationErrors?.getRequiredField("email"),
      invalidMessage = validationErrors?.email?.invalid,
      maxLengthMessage = validationErrors?.getMaxLength(
        "email",
        fieldLengths?.email?.max
      ),
    } = options;

    return Yup.string()
      .required(requiredMessage)
      .test("email-format", invalidMessage, (value) => {
        if (!value) return false;
        if (!emailRegex?.test(value)) return false;
        if (value?.includes("..")) return false;
        if (value?.includes("@@")) return false;
        if (value?.startsWith(".")) return false;
        if (value?.endsWith(".")) return false;
        return true;
      })
      .max(fieldLengths?.email?.max, maxLengthMessage);
  },

  validatePassword: (options = {}) => {
    const {
      fieldName = "password",
      requiredMessage = validationErrors?.getRequiredField(fieldName),
    } = options;

    return Yup.string()
      .required(requiredMessage)
      .min(8, validationErrors?.password?.minLength)
      .matches(passwordRegex?.uppercase, validationErrors?.password?.uppercase)
      .matches(passwordRegex?.lowercase, validationErrors?.password?.lowercase)
      .matches(passwordRegex?.number, validationErrors?.password?.number)
      .matches(
        passwordRegex?.specialChar,
        validationErrors?.password?.specialChar
      );
  },

  validateName: (fieldKey, options = {}) => {
    const fieldName = fieldKey?.toLowerCase()?.replace("_", " ");
    const {
      requiredMessage = validationErrors?.getRequiredField(fieldName),
      minLengthMessage = validationErrors?.getMinLength(
        fieldName,
        fieldLengths?.[fieldKey]?.min
      ),
      maxLengthMessage = validationErrors?.getMaxLength(
        fieldName,
        fieldLengths?.[fieldKey]?.max
      ),
    } = options;

    return Yup.string()
      .trim()
      .required(requiredMessage)
      .min(fieldLengths?.[fieldKey]?.min, minLengthMessage)
      .max(fieldLengths?.[fieldKey]?.max, maxLengthMessage);
  },

  validatePhoneNumber: (options = {}) => {
    const {
      requiredMessage = validationErrors?.getRequiredField("phone number"),
    } = options;

    return Yup.string().required(requiredMessage);
  },

  validateRequiredAddress: (fieldKey, options = {}) => {
    let fieldName = fieldKey?.toLowerCase()?.replace("_", " ");
    fieldName = fieldName === "zipcode" ? "zip code" : fieldName;
    const {
      requiredMessage = validationErrors?.getRequiredField(fieldName),
      maxLengthMessage = validationErrors?.getMaxLength(
        fieldName,
        fieldLengths?.[fieldKey]?.max
      ),
    } = options;

    return Yup.string()
      .trim()
      .required(requiredMessage)
      .max(fieldLengths?.[fieldKey]?.max, maxLengthMessage);
  },

  validateCaptchaValue: (options = {}) => {
    const {
      requiredMessage = validationErrors?.getRequiredField("captcha value"),
    } = options;
    return Yup.string().trim().required(requiredMessage);
  },

  validateUnRequiredAddress: (fieldKey, options = {}) => {
    let fieldName = fieldKey?.toLowerCase()?.replace("_", " ");
    fieldName = fieldName === "zipcode" ? "zip code" : fieldName;
    const {
      maxLengthMessage = validationErrors?.getMaxLength(
        fieldName,
        fieldLengths?.[fieldKey]?.max
      ),
    } = options;

    return Yup.string().max(fieldLengths?.[fieldKey]?.max, maxLengthMessage);
  },

  validateUnrequiredPatientField: (fieldKey, options = {}) => {
    const fieldName = fieldKey?.toLowerCase()?.replace("_", " ");
    const {
      maxLengthMessage = validationErrors?.getMaxLength(
        fieldName === "patient id"
          ? "id"
          : fieldName === "medical recommendation"
          ? "medical id"
          : fieldName,
        fieldLengths?.[fieldKey]?.max
      ),
    } = options;

    return Yup.string().max(fieldLengths?.[fieldKey]?.max, maxLengthMessage);
  },
};

export default validationUtils;
